module.exports = __webpack_public_path__ + "media/bootstrap-icons/printer-fill-011d5ce6.svg";